import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "text-right" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "text-right" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "text-right" };
const _hoisted_6 = { class: "text-right" };
const _hoisted_7 = { class: "text-right" };
const _hoisted_8 = { key: 0 };
const _hoisted_9 = { class: "text-right" };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "text-right" };
const _hoisted_12 = { key: 2 };
const _hoisted_13 = { class: "text-right" };
const _hoisted_14 = { class: "text-right" };
const _hoisted_15 = { class: "text-right" };
const _hoisted_16 = { class: "text-right" };
const _hoisted_17 = { class: "text-right" };
const _hoisted_18 = { class: "text-right" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContractRevisionTable',
    props: {
        revision: {},
        jobSection: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_v_table = _resolveComponent("v-table");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("span", null, "契約No. " + _toDisplayString(_ctx.revision.number), 1),
                _createVNode(_component_v_table, {
                    density: "compact",
                    class: "mt-2",
                    style: { "max-width": "450px" }
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _cache[0] || (_cache[0] = _createElementVNode("td", null, "契約開始日", -1)),
                                _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.revision.startDate), 1)
                            ]),
                            (_ctx.jobSection == '新規接客')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (_ctx.revision.customRewards?.length)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_2, [
                                            _cache[1] || (_cache[1] = _createElementVNode("td", null, "成約報酬", -1)),
                                            _createElementVNode("td", _hoisted_3, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.revision.customRewards, (customReward) => {
                                                    return (_openBlock(), _createElementBlock("p", {
                                                        key: customReward.id
                                                    }, _toDisplayString(customReward.condition) + ": " + _toDisplayString(customReward.amount.toLocaleString()) + " 円 ", 1));
                                                }), 128))
                                            ])
                                        ]))
                                        : (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                                            _cache[2] || (_cache[2] = _createElementVNode("td", null, "成約報酬", -1)),
                                            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.revision.successFee.toLocaleString()) + " 円", 1)
                                        ])),
                                    _createElementVNode("tr", null, [
                                        _cache[3] || (_cache[3] = _createElementVNode("td", null, "接客報酬", -1)),
                                        _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.revision.serviceFee.toLocaleString()) + " 円", 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                        _cache[4] || (_cache[4] = _createElementVNode("td", null, "来館キャンセル補償", -1)),
                                        _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.revision.guaranteeFee.toLocaleString()) + " 円", 1)
                                    ])
                                ], 64))
                                : (_ctx.jobSection == '施行担当')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_ctx.revision.customRewards?.length)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                                                _cache[5] || (_cache[5] = _createElementVNode("td", null, "担当報酬", -1)),
                                                _createElementVNode("td", _hoisted_9, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.revision.customRewards, (customReward) => {
                                                        return (_openBlock(), _createElementBlock("p", {
                                                            key: customReward.id
                                                        }, _toDisplayString(customReward.condition) + ": " + _toDisplayString(customReward.amount.toLocaleString()) + " 円 ", 1));
                                                    }), 128))
                                                ])
                                            ]))
                                            : (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                                                _cache[6] || (_cache[6] = _createElementVNode("td", null, "担当報酬", -1)),
                                                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.revision.successFee.toLocaleString()) + " 円", 1)
                                            ]))
                                    ], 64))
                                    : (_ctx.jobSection == 'イベント・その他')
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                                            _cache[7] || (_cache[7] = _createElementVNode("td", null, "来館キャンセル補償", -1)),
                                            _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.revision.guaranteeFee.toLocaleString()) + " 円", 1)
                                        ]))
                                        : _createCommentVNode("", true),
                            _createElementVNode("tr", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("td", null, "日給", -1)),
                                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.revision.dailyFee.toLocaleString()) + " 円", 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("td", null, "時給", -1)),
                                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.revision.addWorkFee.toLocaleString()) + " 円", 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("td", null, "研修報酬（日給）", -1)),
                                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.revision.trainingFee.toLocaleString()) + " 円", 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[11] || (_cache[11] = _createElementVNode("td", null, "研修報酬（時給）", -1)),
                                _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.revision.hourlyTrainingFee.toLocaleString()) + " 円", 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[12] || (_cache[12] = _createElementVNode("td", null, "備考", -1)),
                                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.revision.detail), 1)
                            ])
                        ])
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
